import { genericPlayerParser } from '../commonInbounds/utils/genericPlayerInboundUtils';
import { inboundPlayerServerSettingsParser } from '../commonInbounds/utils/playerServerSettingsInboundUtils';
import { inboundSelfDataParser } from '../commonInbounds/utils/selfDataInboundUtils';
import { booleanParser, createArrayWithBracesParser, encodedStringParser, numberParser, stringParser } from '../inboundParsers';
export const INIT_LOBBY_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'inboundSelfData', parser: inboundSelfDataParser },
        { name: 'currentRoomId', parser: numberParser },
        { name: 'lobbyPlayers', parser: createArrayWithBracesParser(genericPlayerParser) },
        { name: 'salePercentMore', parser: numberParser },
        { name: 'loungeId', parser: numberParser },
        { name: 'loungeName', parser: encodedStringParser },
        { name: 'loungeOwnerName', parser: encodedStringParser },
        { name: 'loungeRulesText', parser: encodedStringParser },
        { name: 'loungeRulesDataString', parser: stringParser }, // TODO: parse full object
        { name: 'numVisibleLounges', parser: numberParser },
        { name: 'timebombMs', parser: numberParser },
        { name: 'showLobbyTraffic', parser: booleanParser },
        { name: 'showSortOptions', parser: booleanParser },
        { name: 'isNinjaAdmin', parser: booleanParser },
        { name: 'isNinjaOn', parser: booleanParser },
        { name: 'showHowToPlay', parser: booleanParser },
        { name: 'inboundPlayerServerSettings', parser: inboundPlayerServerSettingsParser },
        { name: 'newbieRestrictedSettingsString', parser: stringParser } // TODO: parse full object
    ]
};
